import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { omitProps } from '@instructure/ui-react-utils';
import { Button } from '@instructure/ui-buttons';
var hideStyle = {
  position: 'absolute',
  left: '-9999px'
};
export var HideableButton = /*#__PURE__*/function (_Component) {
  function HideableButton() {
    var _this;
    _classCallCheck(this, HideableButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HideableButton, [].concat(args));
    _defineProperty(_this, "state", {
      focused: false
    });
    _defineProperty(_this, "focus", function () {
      _this.button && _this.button.focus();
      _this.handleFocus();
    });
    _defineProperty(_this, "handleRef", function (node) {
      _this.button = node;
    });
    _defineProperty(_this, "handleFocus", function () {
      return _this.setState({
        focused: true
      });
    });
    _defineProperty(_this, "handleBlur", function () {
      return _this.setState({
        focused: false
      });
    });
    return _this;
  }
  _inherits(HideableButton, _Component);
  return _createClass(HideableButton, [{
    key: "render",
    value: function render() {
      var focused = this.state.focused;
      var _this$props = this.props,
        unfocusedShow = _this$props.unfocusedShow,
        show = _this$props.show;
      var hide = !focused && !unfocusedShow && !show;
      return /*#__PURE__*/React.createElement("div", {
        style: hide ? hideStyle : null
      }, /*#__PURE__*/React.createElement(Button, Object.assign({
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        ref: this.handleRef
      }, omitProps(this.props, HideableButton.propTypes)), this.props.children));
    }
  }]);
}(Component);
_defineProperty(HideableButton, "propTypes", {
  show: PropTypes.bool,
  unfocusedShow: PropTypes.bool,
  children: PropTypes.node
});
_defineProperty(HideableButton, "defaultProps", {
  show: false,
  unfocusedShow: false,
  children: void 0
});
export default HideableButton;